import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { HasuraQueries } from "@/api/hasura/queries"
import {
  ITradesElecData,
  ITradesElecHistoryData,
  ITradesElecNominationsData,
} from "@/models/operations/tradingData/elecData.types"
import {
  TradesElecDataParser,
  TradesElecHistoryDataParser,
  TradesElecNominationsDataParser,
} from "@/models/operations/tradingData/elecData.parser"
import {
  ITradesGasData,
  ITradesGasHistoryData,
} from "@/models/operations/tradingData/gasData.types"
import {
  TradesGasDataParser,
  TradesGasHistoryDataParser,
} from "@/models/operations/tradingData/gasData.parser"

export interface ITradingDataService {
  getElecData(): QueryResult<ITradesElecData[]>
  getGasData(): QueryResult<ITradesGasData[]>
}

class TradingDataServiceClass implements ITradingDataService {
  getElecData(): QueryResult<ITradesElecData[]> {
    return useQuery({
      ...HasuraQueries.tradingData.elecData,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.ElecTrades.map((trade) =>
          TradesElecDataParser.toDomain(trade),
        ) as ITradesElecData[],
    })
  }
  getGasData(): QueryResult<ITradesGasData[]> {
    return useQuery({
      ...HasuraQueries.tradingData.gasData,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.GasTrades.map((trade) =>
          TradesGasDataParser.toDomain(trade),
        ) as ITradesGasData[],
    })
  }
  getElecHistoryData(): QueryResult<ITradesElecHistoryData[]> {
    return useQuery({
      ...HasuraQueries.tradingData.elecHistoryData,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.ElecTradesHistory.map((trade) =>
          TradesElecHistoryDataParser.toDomain(trade),
        ) as ITradesElecHistoryData[],
    })
  }
  getGasHistoryData(): QueryResult<ITradesGasHistoryData[]> {
    return useQuery({
      ...HasuraQueries.tradingData.gasHistoryData,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.GasTradesHistory.map((trade) =>
          TradesGasHistoryDataParser.toDomain(trade),
        ) as ITradesGasHistoryData[],
    })
  }
  getElecNominationsData(): QueryResult<ITradesElecNominationsData[]> {
    return useQuery({
      ...HasuraQueries.tradingData.elecNominationsData,
      placeholderData: [],
      useRawResponse: true,
      parserFn: (data) =>
        data.ElecNominations.map((trade) =>
          TradesElecNominationsDataParser.toDomain(trade),
        ) as ITradesElecNominationsData[],
    })
  }
}

export const TradingDataService = new TradingDataServiceClass()
